// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/prompt',
    name: 'ManagePrompt',
    component: layout,
    redirect: '/prompt/promptTest',
    meta: {
      title: '提示词',
      roles: [0]
    },
    sort: 6,
    children: [
      {
        path: 'promptTest',
        name: 'ManagePromptTestIndex',
        component: () => import('@/views/Manage/PromptTest.vue'),
        meta: {
          title: '提示词测试',
          icon: 'i-tabler:prompt',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
